/** Outer yellow band (pasteboard side of dashed trim), top — centered per page half. */
export const OUTER_YELLOW_BLEED_COPY =
  'For bleeds, make sure elements extend all the way to the outer edge of the colored area.'

/** Inner yellow band (between dashed trim and live page), top and bottom — centered per page half. */
export const INNER_YELLOW_TRIM_COPY =
  'To avoid trimming, keep important content out of the colored area.'

/** Spine gutter warning — shown only when print bleed is visible. */
export const GAP_WARNING =
  'To avoid having elements get lost in the gutter, keep important content away from colored area.'
